import { useQuery } from '@apollo/client/react';
import { NextPageWithLayout } from '@scorenco/next';
import { useRouter } from 'next/router';

import { ScreenViewer } from '../../components';
import { ScreenLayout } from '../../layouts';

import { GetClubHouseDocument } from './_internal/GetClubhouse.query.generated';

const Screen: NextPageWithLayout = () => {
  const router = useRouter();
  const getClubHouseQuery = useQuery(GetClubHouseDocument, {
    variables: {
      clubhouseId: Number(router.query.clubhouseId),
    },
    context: {
      role: 'anonymous',
    },
    pollInterval: 60000,
  });

  if (!getClubHouseQuery.data?.clubhouse) {
    return null;
  }

  return <ScreenViewer clubHouse={getClubHouseQuery.data.clubhouse} />;
};

export const getStaticProps = ScreenLayout.buildGetStaticProps();

export const getStaticPaths = ScreenLayout.buildGetStaticPaths();

Screen.getLayout = ScreenLayout.buildGetLayout();

export default Screen;
